import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
export default function Modal(props) {
    const navigate = useNavigate()
    useEffect(() => {
        setHidden(props.hidden)
    }, [props])

    const [hidden, setHidden] = useState(props.hidden)
    const { message, animation } = props
    const { onModalClose, onRestartGame } = props

    function onClose() {
        setHidden(true)
        onModalClose()
    }

    function OnRestartGame() {
        onRestartGame()
    }

    return (
        <div id="modal" className={`fixed ${hidden ? 'hidden' : null} z-50 inset-0 bg-gray-900 bg-opacity-60 overflow-y-auto h-full w-full px-4`}>
            <div className={`animate__animated animate__${animation} relative top-40 mx-auto shadow-lg rounded-md bg-white max-w-md`}>


                <div className="flex justify-between items-center bg-green-500 text-white text-xl rounded-t-md px-4 py-2">
                    <h3>Win!</h3>
                    <button onClick={() => onClose()}>x</button>
                </div>

                <h1 className="text-center">{message}</h1>

                

                <div className="px-4 py-2 border-t border-t-gray-500 flex justify-end items-center space-x-4">
                    <button onClick={() => onClose()} className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-700 transition">Close</button>
                    <button onClick={() => {onClose(); onRestartGame()}} className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-700 transition">Restart</button>
                </div>
            </div>
        </div>
    )
}